// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { LASWorkerLoader } from "./las-loader.js";
import { parseLAS } from "./lib/laz-perf/parse-las.js";
/**
 * Loader for the LAS (LASer) point cloud format
 * @note Does not support LAS v1.4
 */
export const LAZPerfLoader = {
    ...LASWorkerLoader,
    parse: async (arrayBuffer, options) => parseLAS(arrayBuffer, options),
    parseSync: (arrayBuffer, options) => parseLAS(arrayBuffer, options)
};
//# sourceMappingURL=lazperf-loader.js.map